/** Event a microfrontend dispatches on window to ask the host to run an action. */
export const MICROFRONTEND_ACTION_REQUEST = 'microfrontend-action-request';

export interface MicrofrontendActionResult {
  /** `completed` when the flow finished or was closed, `cancelled` when the host aborted it. */
  status: 'completed' | 'cancelled';
  /** Whether the flow may have changed data shown by the microfrontend. */
  changed: boolean;
}

export interface MicrofrontendActionRequestDetail {
  action: string;
  source: string;
  payload?: Record<string, unknown>;
  callbackFn: (result: MicrofrontendActionResult) => void;
  errorFn: (error: unknown) => void;
}

export type MicrofrontendActionHandler = (
  payload?: Record<string, unknown>
) => Promise<MicrofrontendActionResult>;
